// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mail-warning';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.96 15.768c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288' />
    <path d='M12.96 13.536v-2.232m4.32 4.176c.072.216.144.432.144.648s-.072.432-.216.648-.288.36-.504.432c-.216.144-.432.144-.648.144H9.72c-.216 0-.432-.072-.648-.144a3.132 3.132 0 0 1-.504-.432c-.144-.216-.216-.432-.216-.648s.072-.432.144-.648l3.168-6.336c.144-.216.288-.432.504-.504.216-.144.432-.216.72-.216.216 0 .504.072.72.216s.36.288.504.504z' />
    <path d='M6.192 11.808H1.656a1.137 1.137 0 0 1-1.152-1.152v-9c0-.648.504-1.152 1.152-1.152h13.536c.648 0 1.152.504 1.152 1.152v5.04' />
    <path d='m16.056 1.008-6.12 4.68c-.864.72-2.16.72-3.024 0l-6.12-4.68' />
  </g>
);

export const viewBox = '0 0 18 18';
